export const CASHBACK_REWARDS_PATH = '/company/:companyId/:gameId/engagement/cashback-rewards'
export const CASHBACK_REWARDS_CREATE_PATH = `${CASHBACK_REWARDS_PATH}/create`
export const CASHBACK_REWARDS_EDIT_PATH = `${CASHBACK_REWARDS_PATH}/:rewardId`
export const REWARD_POINTS_EDIT_PATH = `${CASHBACK_REWARDS_PATH}/reward_points`
export const LOYALTY_POINTS_EDIT_PATH = `${CASHBACK_REWARDS_PATH}/loyalty_points`
